export default function IconArr(props: any) {
    return (
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                id="Vector"
                d="M8.76465 1.51367L4.99994 5.27838L1.23524 1.51367"
                stroke="#9A9A9A"
                strokeWidth="1.41176"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
